import {
    Component,
    OnInit,
    ChangeDetectorRef,
    ViewChild,
    ElementRef,
} from '@angular/core';
import { DomSanitizer, SafeHtml, Title } from '@angular/platform-browser';
import * as moment from 'moment';

import {
    ILabChildOrder,
    ILabOrder,
    ILabResearch,
    ILabResearchForm,
    IResearchForm,
    IResearchFormBio,
} from '../../../interfaces/lab.interface';
import { IResearchFileList } from '../../../interfaces/laboratory-services.interface';
import { IPeriod } from '../../../interfaces/period.interface';
import { ConfigService } from '../../../services/application/config.service.';
import { LoadService } from '../../../services/application/load.service';
import { AuthService } from '../../../services/auth.service';
import { compToPagination } from '../../../services/compToPagination';
import { LabService } from '../../../services/lab.service';
import { Size } from '../../../services/size';
import {
    getNameDay,
    getStrEnd,
    getTekDay,
    getTekDayDATE,
    getTime,
} from '../../application/global.function';
import { IDateRange } from 'src/app/interfaces/date-range.interface';
import { PayPeriodDialogComponent } from '../../payments/dialogs/pay-period-dialog/pay-period-dialog.component';

@Component({
    selector: 'app-labs-pc',
    templateUrl: './labs-pc.component.html',
    styleUrls: ['./labs-pc.component.scss'],
})
export class LabsPcComponent implements OnInit {
    //    blockBodystyleHeight = {height:'auto'};
    dtBegin: Date | null = null; // Дата начала
    dtEnd: Date | null = null; // Дата ококнчания
    orderUP = true; // С начала последние
    orderUPText: string = 'Сначала последние';
    isCovid = false; // КОВИД значение

    orderList: ILabOrder[] | null = null;
    selectedOrder: ILabOrder | null = null; // Выбранный заказ
    labResearchs: ILabResearch[] | null = null;
    mobileVersion: boolean = false;
    labResult: ILabResearchForm[] = []; // Итоговый результат
    public labOrdersChild: ILabChildOrder['research_child_list'] = [];
    orderListLength: number = 0; // Количество записей
    countRectoPage = 10; // Количетсво записей на странице

    loadingOrderList = false; // Загрузка заказов
    loadingResearchList = false; // Загрузка результатов
    private _setting: any;
    public onlyPdf = false; // Только документы и PDF (// Отображать результаты только в PDF)
    public pdfHtml: SafeHtml | null = null; // HTML pdf файла
    buttonNameEnabled: string = '';
    isNotSecondClick: boolean = false;
    ButtonActiveColorOneDay: boolean = false;
    isNotShowResult = false;
    selectedButton: 'today' | '3days' | 'all' | null = 'all';
    pdfLoading = false;
    isMobile: boolean = false;
    public loadingPdfIds: Set<number> = new Set();
    private resizeHandler!: () => void;
    loadedPages = 0;
    viewPage = 1;
    loadingMoreContent = false;
    isLoadingMore = false;
    loadingList: boolean = false;
    private loaderTimer: any;
    showDetails: boolean = false;
    isSlideOut: boolean = false;

    @ViewChild('wrapperElement') wrapperElement: ElementRef | undefined;
    dialog: any;
    alert: any;

    constructor(
        private lab: LabService,
        private size: Size,
        private cToP: compToPagination,
        private configS: ConfigService,
        private load: LoadService,
        private title: Title,
        private sanitizer: DomSanitizer,
        private cdr: ChangeDetectorRef
    ) {
        moment.locale('ru');
        this._setting = load.configData.pages.laboratory;
        if (this._setting && this._setting.title) {
            this.title.setTitle(this._setting.title);
        }

        if (this._setting.WEB_LK_LAB_SHOW_RES_ONLY_PDF) {
            this.onlyPdf = this._setting.WEB_LK_LAB_SHOW_RES_ONLY_PDF == 1;
        }
    }

    ngOnInit(): void {
        // this.dtBegin = new Date();
        // this.dtBegin.setDate(this.dtBegin.getDate() - 365);
        this.dtBegin = new Date(2000, 0, 1);
        this.dtEnd = new Date();
        this.changePeriod({ begin: this.dtBegin, end: this.dtEnd });

        this.isMobile = window.innerWidth <= 767;

        this.resizeHandler = () => {
            this.isMobile = window.innerWidth <= 767;
        };

        window.addEventListener('resize', this.resizeHandler);
    }

    ngOnDestroy(): void {
        if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler);
        }
        if (this.loaderTimer) {
            clearTimeout(this.loaderTimer);
        }
    }

    // Количество записей
    // Количество записей
    getOrdersSize() {
        this.loadingOrderList = true;
        this.orderList = null;
        this.labOrdersChild = [];
        this.selectedOrder = null;

        this.lab.getLaboratoryOrderSize(this.dtBegin, this.dtEnd).subscribe(
            async (res) => {
                if (res.size) {
                    this.orderListLength = res.size;
                    this.countOfPages = Math.ceil(
                        this.orderListLength / this.countRectoPage
                    );
                    try {
                        await this.getOrders(1, this.countRectoPage);
                    } finally {
                        this.loadingOrderList = false; // ✅
                    }
                } else {
                    this.orderListLength = 0;
                    this.countOfPages = 1;
                    this.loadingOrderList = false;
                }
            },
            (err) => {
                console.error('ERRROr=', err);
                this.loadingOrderList = false;
            }
        );
    }

    CurentPage: number = 0;
    loading = false; // Загрузка талонов
    countOfPages = 1;
    private scrollTimeout: any;

    async onScroll(event: Event) {
        // Use debouncing to prevent too many calls
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(async () => {
            const gridBody = document.querySelector('.grid-body');
            if (!gridBody) return;

            const lastGridRow = gridBody.querySelector('.grid-row:last-child');
            if (!lastGridRow) return;

            const rect = lastGridRow.getBoundingClientRect();
            const windowHeight =
                window.innerHeight || document.documentElement.clientHeight;

            const isLastRowVisible =
                rect.bottom <= windowHeight &&
                rect.bottom > 0 &&
                !this.loadingMoreContent &&
                !this.isLoadingMore;

            if (isLastRowVisible && this.loadedPages < this.countOfPages) {
                this.loadMoreData();
            }
        }, 300);
    }

    async loadMoreData() {
        if (
            this.loadingMoreContent ||
            this.isLoadingMore ||
            this.loadedPages >= this.countOfPages
        ) {
            return;
        }

        this.loadingMoreContent = true;
        this.loadingList = true;
        this.cdr.markForCheck();

        this.loadedPages++;

        const pStart =
            this.loadedPages * this.countRectoPage - this.countRectoPage + 1;
        const pEnd = this.loadedPages * this.countRectoPage;

        try {
            await this.getOrders(pStart, pEnd);
        } finally {
            this.loadingMoreContent = false;
            this.loadingList = false;
            this.cdr.markForCheck();
        }
    }

    getOrders(pStart?: number, pEnd?: number) {
        this.loadingList = true;
        let order = this.orderUP ? 'desc' : 'asc';

        return new Promise<void>((resolve, reject) => {
            this.lab
                .getLaboratoryOrderList(
                    this.dtBegin,
                    this.dtEnd,
                    pStart,
                    pEnd,
                    order
                )
                .subscribe(
                    (res) => {
                        // Обработка дат
                        const processedRes = res.map((item) => ({
                            ...item,
                            dtSort: new Date(
                                item.regdate.replace(
                                    /(\d+).(\d+).(\d+)/,
                                    '$3/$2/$1'
                                )
                            ),
                        }));

                        if (!this.orderList || pStart === 1) {
                            this.orderList = processedRes;
                        } else {
                            // ✅ Всегда добавляем в конец — порядок гарантируется бэкендом
                            this.orderList = [
                                ...this.orderList,
                                ...processedRes,
                            ];
                        }

                        // Выбор первого заказа
                        if (
                            this.orderList.length > 0 &&
                            pStart === 1 &&
                            !this.isMobile
                        ) {
                            this.selectOrder(this.orderList[0]);
                        } else {
                            this.mobileVersion = true;
                            this.isSlideOut = true;
                        }

                        this.loadingList = false;
                        resolve();
                    },
                    (err) => {
                        console.error('ERRROr=', err);
                        this.loadingList = false;
                        reject(err);
                    }
                );
        });
    }

    checkEnabledButton(buttonName: string) {
        if (this.buttonNameEnabled === '') {
            this.buttonNameEnabled = buttonName;
            return true;
        } else {
            if (this.buttonNameEnabled === buttonName) {
                this.ngOnInit();
                this.buttonNameEnabled = '';
                return false;
            } else {
                this.buttonNameEnabled = buttonName;
                return true;
            }
        }
    }

    // За сегодня
    btnFiltrTek() {
        // this.isNotSecondClick = this.checkEnabledButton('oneDay');
        // this.selectedButton = this.selectedButton === 'today' ? null : 'today';
        this.selectedButton = 'today';
        // if (this.isNotSecondClick) {
        this.dtBegin = new Date();
        this.dtEnd = new Date();
        this.customDateSelected = false;
        this.changePeriod({ begin: this.dtBegin, end: this.dtEnd });
        // }
    }
    // За 3 дня
    btnFiltr3Day() {
        // this.isNotSecondClick = this.checkEnabledButton('threeDays');
        this.selectedButton = this.selectedButton === '3days' ? null : '3days';
        this.selectedButton = '3days';
        // if (this.isNotSecondClick) {
        this.dtBegin = new Date();
        this.dtBegin.setDate(this.dtBegin.getDate() - 3);
        this.dtEnd = new Date();
        this.customDateSelected = false;
        this.changePeriod({ begin: this.dtBegin, end: this.dtEnd });
        // }
    }
    // За Все время
    btnAllDays() {
        // this.selectedButton = this.selectedButton === 'all' ? null : 'all';
        // this.isNotSecondClick = this.checkEnabledButton('AllDays');
        this.selectedButton = 'all';
        // if (this.isNotSecondClick) {
        this.dtBegin = new Date(2000, 0, 1);
        this.dtEnd = new Date();
        this.customDateSelected = false;
        this.changePeriod({ begin: this.dtBegin, end: this.dtEnd });
        // }
    }
    customDateSelected = false;
    onDateRangeChanged(period: IPeriod) {
        // Обновляем начало и конец периода
        this.dtBegin = period.begin;
        this.dtEnd = period.end;
        this.customDateSelected = true;
        this.selectedButton = 'all';
        // Перезагружаем список платежей
        this.changePeriod({ begin: this.dtBegin, end: this.dtEnd });
    }

    // sortUp() {
    //     this.cToP.setPage(1); // Переходим на первую страницу

    //     if (this.orderList) {
    //         this.orderList.sort((a, b) => (a.dtSort < b.dtSort ? 1 : -1));
    //     }
    // }

    // sortAp() {
    //     this.cToP.setPage(1); // Переходим на первую страницу

    //     if (this.orderList) {
    //         this.orderList.sort((a, b) => (a.dtSort > b.dtSort ? 1 : -1));
    //     }
    // }

    // С начала последние
    btnFiltrOrderUp() {
        this.orderUP = !this.orderUP;
        this.orderUPText = this.orderUP
            ? 'Сначала последние'
            : 'Сначала первые';

        // Сброс состояния
        this.loadedPages = 1;
        this.viewPage = 1;
        this.orderList = null;
        this.selectedOrder = null;
        this.mobileVersion = false;
        this.isSlideOut = false;

        // Перезапрос с новой сортировкой
        this.getOrdersSize();
    }

    getTekDay(dt: Date | null | undefined): string {
        if (dt) {
            return getTekDay(dt);
        } else {
            return '!';
        }
    }

    getNameDay(dt: Date): string {
        return getNameDay(dt);
    }

    getTime(dt: Date): string {
        return getTime(dt);
    }

    changePeriod(dt: IPeriod) {
        this.dtBegin = dt.begin;
        this.dtEnd = dt.end;

        this.loadedPages = 1;
        this.viewPage = 1;
        this.getOrdersSize();
        // this.loadedPages++;
    }

    isBlockYeer(index: number): boolean {
        let f = false;
        if (
            this.orderList &&
            this.orderList[index] &&
            this.orderList[index - 1]
        ) {
            if (
                this.orderList[index].dtSort.getFullYear() !==
                this.orderList[index - 1].dtSort.getFullYear()
            ) {
                f = true;
            }
        }
        if (index === 0) {
            f = true;
        }
        return f;
    }

    getYeer(index: number): string {
        if (this.orderList && this.orderList[index]) {
            return this.orderList[index].dtSort.getFullYear() + '';
        } else {
            return '';
        }
    }

    public selectOrder(order: ILabOrder) {
        if (this.selectedOrder?.research_id === order.research_id) {
            return;
        } else {
            this.selectedOrder = order;

            this.loadingResearchList = true;
            // this.lab
            //     .getLaboratoryChildResearch(order.research_id)
            //     .subscribe((res) => {
            //         this.labOrdersChild = res;
            //         this.loadingResearchList = false;
            //     });
        }
        if (this.isMobile) {
            this.mobileVersion = true;
        }
    }

    pickedResearch: ILabChildOrder['research_child_list'][0] = {
        ext_results: 0,
        internal_order: 0,
        research_id: 0,
        text_status: '',
        specimen: '',
    };

    openDocReseachChildModal(
        result: ILabChildOrder['research_child_list'][0],
        e: Event
    ) {
        if (result.text_status.trim().toLowerCase() !== 'выполнен') {
            e.stopPropagation();
            e.preventDefault();
            return;
        }
        this.pickedResearch = result;
        e.stopPropagation();
        this.showDetails = true;
    }

    isPdfLoading(researchId: number | undefined): boolean {
        return researchId ? this.loadingPdfIds.has(researchId) : false;
    }

    getDownloadUrlForPDF(researchId: number | undefined, type: string) {
        return `/labs/pdf/${researchId}.pdf?type=${type}`;
    }

    public pdfPreview(file: IResearchFileList): void {
        //
        let pdfPatch = '';
        this.pdfHtml = null;
        if (file) {
            pdfPatch =
                this.configS.getValue('hostBackend') +
                `/labs/research/${file.researchId}/patient/${null}/file/${
                    file.id
                }/type/${file.file_type}/${file.file_name}`;
            this.pdfHtml = this.sanitizer.bypassSecurityTrustHtml(
                `<embed src="${pdfPatch}" type="application/pdf" width="100%" height="680px">`
            );
            //
        }
    }

    public selectPDFPreview(researchFileList: IResearchFileList[]): void {
        this.pdfHtml = null;
        if (researchFileList.length > 0) {
            let sFile: IResearchFileList;
            const lab_RESEARCH_DOCUMENT = researchFileList.filter(
                (fItem) => fItem.file_type === 'LAB_RESEARCH_DOCUMENT'
            );
            //

            if (lab_RESEARCH_DOCUMENT.length > 0) {
                sFile = lab_RESEARCH_DOCUMENT[0];
                lab_RESEARCH_DOCUMENT.forEach((item) => {
                    if (item.id > sFile.id) {
                        sFile = item;
                    }
                });
            } else {
                sFile = researchFileList[0];
                researchFileList.forEach((item) => {
                    if (item.id > sFile.id) {
                        sFile = item;
                    }
                });
            }
            this.pdfPreview(sFile);
        }
    }

    /* Получить список документов по номеру заказа */
    private getResearchFileList(researchId: number): void {
        let researchFileList: IResearchFileList[] = [];

        this.lab.getResearchFileList(researchId).subscribe(
            (res) => {
                researchFileList = res;
                //
                // Дополнение
                researchFileList.forEach((item) => {
                    item.researchId = researchId;
                    let fileName = ' ' + item.fileName;
                    fileName = fileName.split('/').join('');
                    fileName = fileName.split(String.fromCharCode(92)).join('');
                    fileName = fileName.split(String.fromCharCode(32)).join('');
                    item.fileName = fileName;
                });
                this.selectPDFPreview(researchFileList);
            },
            (err) => {
                console.error('getResearchFileList=', err);
                this.loadingResearchList = false;
            }
        );
    }

    clearSelectedOrder(e?: Event) {
        if (e) {
            e.stopPropagation();
        }
        this.selectedOrder = null;
        this.mobileVersion = false;
        this.isSlideOut = false;
    }

    paginationText(): string {
        const maxPages = Math.floor(this.orderListLength / 10);
        return `страница ${this.loadedPages} из ${maxPages}`;
    }

    private calculateMaxPages(): number {
        return Math.ceil(this.orderListLength / this.countRectoPage);
    }

    get maxPages(): number {
        return this.calculateMaxPages();
    }
    /* Событие выбора страницы */
    changedPage(page: any) {
        //

        if (page === 1) {
            this.getOrders(1, this.countRectoPage);
        } else {
            this.getOrders(
                page * this.countRectoPage - this.countRectoPage + 1,
                page * this.countRectoPage
            );
        }
    }
    periodText = 'За всё время';
    /** Полученеи текста из периода */
    getPeriodText(dt: IDateRange) {
        let periodText = '';
        let isSelectedOneDay = dt.str_begin === dt.str_end;

        if (isSelectedOneDay) {
            if (dt.dt_begin == null && dt.dt_end == null)
                periodText = 'За всё время';
            else if (dt.dt_begin?.toDateString() === new Date().toDateString())
                periodText = 'Последние посещения';
            else if (dt.str_begin) periodText = dt.str_begin;
        } else if (dt.str_begin && dt.str_end) {
            periodText = `${dt.str_begin} - ${dt.str_end}`;
        } else if (dt.str_begin) {
            periodText = dt.str_begin;
        } else if (dt.str_end) {
            periodText = dt.str_end;
        }

        return periodText;
    }

    /** Вызов диалога для выбора периода */
    showPeriodDialog() {
        const periodDialog = this.dialog.open(PayPeriodDialogComponent, {
            maxWidth: '650px',
            width: '100%',
            height: '100%',
            data: {
                dateRange: {
                    dt_begin: this.dtBegin,
                    dt_end: this.dtEnd,
                } as IDateRange,
            },
        });

        // periodDialog.afterClosed().subscribe((result: any) => {
        //     if (result?.date) {
        //         this.loading = true;
        //         this.changePeriod(result.date).then(
        //             () => (this.loading = false)
        //         );
        //     }
        // });
    }
}
